import React, {useCallback, useRef, useState} from 'react'
import {findDOMNode} from "react-dom"

import HintPopover from "../../../../../../core/gd-ui/hint-popover/hint-popover"
import AddViewPopover from "../../../../../../core/gd-ui/add-view/add-view-popover"
import getNewPortfolioViewItemsGrouped from "../../../../../../core/model2/custom-view/add-custom-view/structure-portfolio-add-view"
import {PopoverAttachmentType} from "../../../../../../core/gd-components/gd-popover/@const";

type Props = {
    className?          : string

    projectCollectionId : ID
    selectedGroupId?    : ID

    onTogglePopover?    : {(value:boolean):void}
}

// const debug = "AddPortfolioView"
const debug = false

export default function AddPortfolioView(props: Props) {

    const selfRef:any                   = useRef()
    const [showPopover, setShowPopover] = useState(false)

    const onShowPopover = useCallback((e?:any) => {
        if (e) e.stopPropagation()

        setShowPopover(true)
        props.onTogglePopover && props.onTogglePopover(true)
    }, [])

    const hidePopover = useCallback((e?:any) => {
        if (e) e.stopPropagation()

        setShowPopover(false)
        props.onTogglePopover && props.onTogglePopover(false)
    }, [])

    const classes = Classes(props.className, {
        'show-popover': showPopover
    })

    const buttonClasses = Classes("ui5-control-button s-28 i5-plus fs-14 ui5-color-not-important", {
        'show-popover': showPopover
    })

    const viewsStructure  = getNewPortfolioViewItemsGrouped()

    debug && console.log(debug, 'render', showPopover)

    return (
        <div ref={selfRef} className={classes} onClick={onShowPopover}>
            <div className={buttonClasses}/>

            {showPopover &&
                <AddViewPopover viewsStructure      = {viewsStructure}
                                selectedGroupId     = {props.selectedGroupId}
                                offset              = "0 6"
                                attachment          = "top left"
                                targetAttachment    = "bottom left"
                                attachmentType      = {PopoverAttachmentType.HORIZONTAL}
                                getTargetFunc       = {()=>findDOMNode(selfRef.current)}
                                hidePopover         = {hidePopover}/>}

            {/*{this.state.showPopover &&
                    <AddViewPopover parent      = {this}
                                    hidePopover = {this.hidePopover}>
                        <AddViewPopoverContent hidePopover={this.hidePopover}/>
                    </AddViewPopover>}*/}
            {!showPopover && <HintPopover hint="Add view"/>}
        </div>
    )
}
